import React, { useEffect, useState, useRef } from 'react';
import SvgPv from './SvgPv';
import SvgInverters from './SvgInverters';
import SvgLoad from './SvgLoad';
import SvgHLine from './SvgHLine';
import SvgVLine from './SvgVLine';


function SvgGroupPvAndInvertersAndLoad({ SN, x, y, width, height, Combinations, onGotoIvnerterList }) {
    let master;
    let slaveAs = [];
    let slaveBs = [];
    let slaveCs = [];
    let slaveGs = [];
    let flowingFromPv = false;
    let flowingToGrid = false;
    let flowingFromGrid = false;
    let flowingToLoad = false;
    let invRowsCount = 0;
    let invColumnsCount = 0;
    // The following variables hold statistical values
    let svg_invs_y = 0;
    let svg_invs_y2 = 0;
    let svg_invs_x2 = 0;


    if (Combinations != null) {
        Combinations.forEach((item, index) => {
            let mode = item.InverterConnectionMode ?? 1;
            if ((mode == 1 || mode == 2 || mode == 3 || mode == 4) && item.CombinationMasterOrSlave == 1) {
                master = item;
            }
            if (mode == 1 || mode == 0) {
                slaveGs.push(item);
            } else if (mode == 2) {
                slaveAs.push(item);
            } else if (mode == 3) {
                slaveBs.push(item);
            } else if (mode == 4) {
                slaveCs.push(item);
            }

            if (item.PPV1 != null && item.PPV1 > 0) {
                flowingFromPv = true;
            }
            if (item.PPV2 != null && item.PPV2 > 0) {
                flowingFromPv = true;
            }
            if (item.PAC1Load != null && item.PAC1Load > 0) {
                flowingToLoad = true;
            }
            if (item.PAC1Grid != null && item.PAC1Grid > 0) {
                let v = parseInt(item.PAC1Grid);
                if (v > 0x7fffffff) {
                    v = v - 0x100000000;
                }
                if (v < 0) {
                    flowingFromGrid = true;
                } else if (v > 0) {
                    flowingToGrid = true;
                }
            }
        });
    }
    if (slaveGs.length > 0) {
        if (slaveAs.length > 0) {
            slaveGs.push(...slaveAs);
        }
        if (slaveBs.length > 0) {
            slaveGs.push(...slaveBs);
        }
        if (slaveCs.length > 0) {
            slaveGs.push(...slaveCs);
        }
        invRowsCount = Math.ceil(slaveGs.length / 3);
        invColumnsCount = invRowsCount > 1 ? 3 : slaveGs.length;
    } else {
        let rs = Math.ceil(slaveAs.length / 3);
        let cs = rs > 1 ? 3 : slaveAs.length;
        invRowsCount = rs;
        invColumnsCount = cs;
        rs = Math.ceil(slaveBs.length / 3);
        cs = rs > 1 ? 3 : slaveBs.length;
        invRowsCount += rs;
        invColumnsCount = Math.max(invColumnsCount, cs);
        rs = Math.ceil(slaveCs.length / 3);
        cs = rs > 1 ? 3 : slaveCs.length;
        invRowsCount += rs;
        invColumnsCount = Math.max(invColumnsCount, cs);
    }

    if (invColumnsCount+invRowsCount > 2) {
        svg_invs_x2 = (110 + 15) * invColumnsCount - 15 + 10*2;
        svg_invs_y = (height - (70 + 20) * invRowsCount + 20) / 2;
        svg_invs_y2 = (height + (70 + 20) * invRowsCount - 20)/2 + 10*2;
    } else {
        svg_invs_x2 = 110;
        svg_invs_y = (height - 70) / 2;
        svg_invs_y2 = (height + 70) / 2;
    }
    if (invRowsCount >= 3) {
        let y = (height - (70 + 20) * 3 + 20) / 2;
        let y2 = (height + (70 + 20) * 3 - 20) / 2;
        svg_invs_x2 = svg_invs_x2 / (svg_invs_y2 - svg_invs_y) * (y2 - y);
        svg_invs_y = y;
        svg_invs_y2 = y2;
    }

    console.log("svg_invs_y", svg_invs_y);
    console.log("svg_invs_y2", svg_invs_y2);
    return (<svg x={x} y={y} width={width} height={height}>
        <SvgPv x={18} y={15} Combinations={Combinations}/>

        {/* <rect x={0} y={height/2} width={width} height={height} fill="green" stroke="lightgray" strokeWidth="1" />
        <line x1={0} y1={height/2} x2={width} y2={height/2} stroke="#1d80b5" strokeWidth="5" />
        <rect x={0} y={height/2} width={width} height={30.5} fill="purple" stroke="lightgray" strokeWidth="1" />
        <rect x={0} y={svg_invs_y2} width={width} height={height} fill="red" stroke="lightgray" strokeWidth="1" /> */}

        <SvgInverters x={0} y={svg_invs_y} width={svg_invs_x2} height={svg_invs_y2 - svg_invs_y} invColumnsCount={invColumnsCount} invRowsCount={invRowsCount} slaveAs={slaveAs} slaveBs={slaveBs} slaveCs={slaveCs} slaveGs={slaveGs} onGotoIvnerterList={onGotoIvnerterList}/>
        {/* <rect x={0} y={svg_invs_y} width={svg_invs_x2} height={svg_invs_y2 - svg_invs_y} fill="none" stroke="red" strokeWidth="1" /> */}
        <SvgLoad x={11} y={height - 84 - 15} Combinations={Combinations}/>
        {flowingFromPv && <SvgVLine id={SN+"flowingFromPv"} x={13 + (84 - 6) / 2} y={15 + 84} y2={svg_invs_y} />}
        {flowingToLoad && <SvgVLine id={SN+"flowingToLoad"} x={13 + (84 - 6) / 2} y={svg_invs_y2} y2={height - 84 - 15} />}
        {flowingToGrid && <SvgHLine id={SN+"flowingToGrid"} x={svg_invs_x2} y={height / 2} x2={width - 3} />}
        {flowingFromGrid && <SvgHLine id={SN+"flowingFromGrid"} x={width - 3} y={height / 2} x2={svg_invs_x2} />}
        
        
    </svg>)
}

export default SvgGroupPvAndInvertersAndLoad;